import { Box, BoxProps, ImageProps } from '@jfs/ui-new'
import { FC } from 'react'
import { GridContainerList } from '../../../../components/GridContainerList'

interface NBContainerProps {
  isAllChecked: boolean
  isEdit?: boolean
  setIsAllChecked: (isChecked: boolean) => void
  bankType: number
}

const NBContainer: FC<NBContainerProps> = ({ isAllChecked, isEdit, setIsAllChecked, bankType }: NBContainerProps) => {
  const styles = netbankingStyles()

  return (
    <Box nativeID="showListScrollBar" {...styles.container}>
      <GridContainerList
        type={bankType}
        isAllChecked={isAllChecked}
        isEdit={isEdit}
        setIsAllChecked={setIsAllChecked}
      />
    </Box>
  )
}

const netbankingStyles = () => ({
  container: {
    flex: 1,
    overflowY: 'auto',
    paddingVertical: 16,
  } as BoxProps,
  imageView: {
    height: 24,
    width: 24,
  } as ImageProps,
})

export { NBContainer }
